<template>
  <closeable-dialog
    hash="changelog"
    max-width="600"
    @open="handleDialogOpening()"
  >
    <template v-slot:activator="{ on, attrs }">
      <div
        style="
          border-right: 1px solid #e5e6f0;
          padding-right: 24px;
          padding-left: 24px;
          height: 50%;
        "
      >
        <v-badge
          dot
          :color="hasUnseenUpdates && !hideChangelogBadge ? '#B00020' : 'white'"
        >
          <v-icon
            :class="{ wiggle: hasUnseenUpdates && !hideChangelogBadge }"
            v-bind="attrs"
            v-on="on"
            style="cursor: pointer"
            :color="hasUnseenUpdates ? '#5f5f5f' : '#d9dae4'"
            title="Hinter diesem Geschenk verstecken sich die letzten Neuerungen. Nach dem Öffnen verschwindet das Geschenk nach 30 Tagen."
          >
            {{ mdiGift }}
          </v-icon>
        </v-badge>
      </div>
    </template>

    <template v-slot:header class="text-h5">
      <v-card-title class="text-h5"> Updates </v-card-title>
    </template>

    <div style="width: 100%">
      <v-card-subtitle class="mb-n4 mt-n1">
        <span class="text-subtitle-1">
          Hier findest Du eine Übersicht über größere Neuerungen der letzten
          Zeit. Wenn Du mehr über die einzelnen Änderungen erfahren möchtest,
          klicke auf "Mehr erfahren".
        </span>
      </v-card-subtitle>
      <v-card-text>
        <ChangelogCard
          v-for="item in changelogItems"
          :key="getChangelogItemKey(item)"
          :image="item.image"
          :title="item.title"
          :date="item.date"
          :description="item.description"
          :isNew="lastSeenDate < item.date"
          :tags="item.tags"
          :link="item.link"
        />
      </v-card-text>
    </div>
  </closeable-dialog>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from "vue"
import { mdiGift } from "@mdi/js"
import ChangelogCard from "features/changelog/ChangelogCard.vue"
import { changelogItems } from "util/changelog-items"
import { currentMemberApi } from "store/api"
import CloseableDialog from "components/UI/CloseableDialog.vue"
import { ChangelogItem } from "features/changelog/changelog.types"

export default defineComponent({
  name: "ChangelogEntry",
  components: { CloseableDialog, ChangelogCard },
  props: {
    lastSeen: {
      type: String,
      required: true,
    },
  },
  setup: function (props) {
    const hideChangelogBadge = ref(false)
    const lastSeenDate = computed(
      () => new Date(parseInt(props.lastSeen) * 1000)
    )

    const handleDialogOpening = async () => {
      await currentMemberApi.setChangelogViewedNow()
      hideChangelogBadge.value = true
    }

    const hasUnseenUpdates = computed(() =>
      changelogItems.some((item) => item.date > lastSeenDate.value)
    )

    const getChangelogItemKey = (item: ChangelogItem) =>
      item.title + item.date.toString()

    return {
      mdiGift,
      changelogItems,
      handleDialogOpening,
      hideChangelogBadge,
      lastSeenDate,
      hasUnseenUpdates,
      getChangelogItemKey,
    }
  },
})
</script>

<style scoped>
@keyframes wiggle {
  0%,
  7% {
    transform: rotateZ(0);
  }
  15% {
    transform: rotateZ(-15deg);
  }
  20% {
    transform: rotateZ(10deg);
  }
  25% {
    transform: rotateZ(-10deg);
  }
  30% {
    transform: rotateZ(6deg);
  }
  35% {
    transform: rotateZ(-4deg);
  }
  40%,
  100% {
    transform: rotateZ(0);
  }
}

.wiggle {
  display: inline-block;
  animation: wiggle 2.5s infinite;
}

.wiggle:hover {
  animation: none;
}
</style>
